export default "__VITE_ASSET__iQmeq7JO__"